import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const BtnWrapper = styled.div`
  display: inline-block;
  ${props => props.expand ? `
    min-width: 100%;
    max-width: 100%;
    qds-button {
      min-width: 100%;
      max-width: 100%;
    }
  ` : ''}
`;

class Button extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    icon: PropTypes.string,
    expand: PropTypes.bool
  };

  render = () => {
    const buttonProps = {
      ...this.props
    };

    if (!buttonProps.disabled) {
      delete buttonProps['disabled'];
    }

    if (this.props.id) {
      buttonProps['id'] = this.props.id;
    }

    return (
      <BtnWrapper expand={this.props.expand}>
        <qds-button
          {...buttonProps}
          size="large"
          text={this.props.label}
          icon-name={this.props.icon}
          onClick={(event) => { if (!this.props.disabled) { this.props.onClick(event); }}}
        ></qds-button>
      </BtnWrapper>
    );
  };
}

export default Button;
